import * as React from "react";
import {
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Link,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
export default function ConfirmDialog({
  open,
  onClose,
  title,
  content,
  confirmFn,
  isSuccess,
  error,
  loading = false,
  children,
  disabled = false,
  odooId = true,
}) {
  const { t } = useTranslation();


  return (
    <Dialog
      open={open}
      onClose={(e) => e.preventDefault()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      {!!title && (
        <>
          <DialogTitle id="alert-dialog-title">{t(title)}</DialogTitle>
          <Divider />
        </>
      )}
      <DialogContent>
        {!odooId && (
          <Alert sx={{ mb: 1 }} severity="warning">
            {t("To obtain your tax invoice, please fill in the ")}
            <Link
              component={RouterLink}
              to="/merchant/account/info"
            >
              {t("company details first.")}
            </Link>
          </Alert>
        )}
        {t(content)}
        {children}
      </DialogContent>
      {(isSuccess || !!error) && (
        <DialogContent>
          {isSuccess && (
            <Typography color="green.main">{t("Done successfully")}</Typography>
          )}
          {!!error && <Typography color="error">{t(error)}</Typography>}
        </DialogContent>
      )}
      <Divider />
      <DialogActions>
        <Button
          sx={{ textTransform: "none" }}
          variant="contained"
          onClick={onClose}
        >
          {t("Close")}
        </Button>
        {!!confirmFn && (
          <LoadingButton
            sx={{ textTransform: "none", mx: "4px" }}
            variant="contained"
            onClick={confirmFn}
            autoFocus
            loading={loading}
            disabled={disabled}
          >
            {t("Confirm")}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
}
